<template>
	<div class="topicLibrary">
		<navBar>
			{{ title }}
			<template v-slot:right>
				<div class="font28 mCG">({{listIndex>=0?listIndex+1:0}}/{{listData.length||0}})</div>
			</template>
		</navBar>
		<div class="content-box">
			<div class="danyuan" v-if="isCuo == 1">
				<div class="title font28 mCf df-mc">所属单元：理解概念：三角形的概念及分类</div>
				<div class="cuotiText df-sb df-a">
					<p class="font28 mCr">错题1</p>
					<p class="font24 mCG">完成时间：2024-09-24 10：46：12—10：52：54</p>
				</div>
			</div>
			<div class="ti" v-for="(item, i) in listData" :key="item.id">
				<div class="title font34">
					<!-- <span class="mCG font36">{{ i + 1 }}.</span> -->
					<!-- 三角形的表示方法是什么？ -->
					<p v-html="item.steam"></p>
				</div>
				<template v-if="item.type == 0">
					<div class="content font30">
						<!-- 	<img src="" alt="" />
						“三角形”可以用符号“△”表示，如图所记作示，顶点是A，B，C的三角形,记作△ABC，读作三角形“ABC”.字母的顺序可以自由安排，你认为图中的三角形还能记作什么？(
						).
						<span class="mCG font26">(多选)</span> -->
					</div>
					<div class="xuanBox">
						<div class="xuanItem font30 df-a " v-for="(list,key) in item.option" :key="i+'chlid'+key" @click="xuanClick(list, key)">
							{{list.value}} .<span v-html="list.text"></span>
						</div>
					</div>
				</template>
				<template v-else>
					<!-- <div class="content font30">
						我们知道，利用整式的乘法运算，可得: (1)观察这两个式子可以发现，等式左边是
						<div class="tk tac font34 dui">测试对</div>
						的形式；等式右边是
						<div class="tk tac font34"></div>
						的形式。 败后 (2)从左到右的变形是将 的形式。
					</div> -->
				</template>
			</div>
		</div>
		<div class="footer df-mc">
			<div class="daanBox font30" v-if="ifdaan">
				<div class="daan df-mc">多因式</div>
				<div class="daan df-mc">因式的积</div>
			</div>
			<div class="bnt df-mc mCf font34">确认</div>
		</div>
		<div class="erweima"></div>
	</div>
</template>

<script>
import { deepClone, computeOptionjson } from '@/utils/public';
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.name || '人教版-七年级上册',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			icon6: require('../../assets/img/study/icon-6.png'),
			icon7: require('../../assets/img/study/icon-7.png'),
			icon8: require('../../assets/img/study/icon-8.png'),
			ifdaan: false,
			isCuo: this.$route.query.isCuo || 0,
			xuanIndex: '',
			listIndex:0,
			listData: [{}]
		};
	},
	created() {
		this.getquestionlist();
	},
	methods: {
		deepClone,
		computeOptionjson,
		getquestionlist() {
			this.$api
				.getquestionlist({
					bookid: this.$route.query.bookid,
					chapterid: this.$route.query.id
				})
				.then((res) => {
					let resData = res.data || [];
					for (let i = 0; i < resData.length; i++) {
						let el = resData[i];
						if (el.type == 0) {
							el.option =  this.computeOptionjson(el.option);
						}
					}
					console.log(resData);
					this.listData = resData;
				});
		},
		xuanClick(item, i) {
			this.xuanIndex = i;
		},
		// computedOptions(str) {
		// 	str = str || '';
		// 	str = str.replace(/<ol>/g, '');
		// 	str = str.replace(/<ul>/g, '');
		// 	str = str.replace(/<\/ul>/g, '');
		// 	str = str.replace(/<\/ol>/g, '');
		// 	str = str.replace(/<li>/g, '');
		// 	str = str.replace(/<\/li>/g, '');
		// 	let arr = str.split('\n');
		// 	let targetArr = [];
		// 	console.log(arr)
		// 	for (let i = 0; i < arr.length; i++) {
		// 		if (arr[i]) {
		// 			targetArr.push({
		// 				label: this.computeOptionjson(this.formatMathJaxImg(arr[i])),
		// 				status: 0
		// 			});
		// 		}
		// 	}
		// 	return targetArr;
		// },
		goPage(item) {
			let path = item.name != '同步课堂' ? '/topicLibrary' : '/videolist';
			this.$router.push({
				path: path,
				query: {
					name: '同步课堂',
					type: 0,
					id: 55337,
					istong: 0
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.topicLibrary {
	height: calc(100% - 2.06rem);
	padding: 0rem 0.28rem 0 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		padding-top: 0.35rem;
		.danyuan {
			.title {
				width: 100%;
				height: 0.8rem;
				background: #74b9bc;
				border-radius: 0.4rem;
			}
			.cuotiText {
				width: 100%;
				height: 0.9rem;
				background: #ffffff;
				border-radius: 0.2rem;
				margin-top: 0.25rem;
				margin-bottom: 0.2rem;
				padding: 0 0.28rem;
			}
		}
		.ti {
			margin-bottom: 0.8rem;
			.title {
				color: #974ace;
				padding: 0.1rem 0;
			}
			.xuanBox {
				width: 100%;
				margin-top: 0.3rem;
				.xuanItem {
					width: 100%;
					height: 0.98rem;
					background: #e8f3ff;
					border-radius: 0.1rem;
					margin-bottom: 0.24rem;
					padding-left: 0.28rem;
					&.cuo {
						background: #ffffff;
						border: 1px solid #ec2226;
						color: #ec2226;
					}
					&.dui {
						background: #ffffff;
						border: 1px solid #1ca300;
						color: #1ca300;
					}
				}
			}
			.tk {
				min-width: 0.9rem;
				height: 0.6rem;
				background: #f5faff;
				border-radius: 0.04rem;
				border: 2px solid #d3d3d3;
				display: inline-block;
				flex-shrink: 1;
				vertical-align: middle;
				padding: 0 0.1rem;
				&.active {
					border-color: #6b9bdb;
				}
				&.dui {
					border-color: #1ca300;
					color: #1ca300;
				}
			}
		}
	}
	.footer {
		width: 100%;
		height: 0.98rem;
		background: #f5faff;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		.daanBox {
			width: 100%;
			position: absolute;
			top: -2.25rem;
			left: 0;
			padding: 0.16rem 0.28rem 0;
			background-color: #ffffff;
			.daan {
				width: 100%;
				height: 0.88rem;
				background: #ffffff;
				border-radius: 0.44rem;
				border: 1px solid #6b9bdb;
				margin-bottom: 0.16rem;
				color: #6b9bdb;
			}
		}
		.bnt {
			width: 5.6rem;
			height: 0.88rem;
			background: #c6d6ef;
			border-radius: 0.44rem;
		}
	}
	.erweima {
		width: 0.92rem;
		height: 0.92rem;
		background: url('../../assets/img/study/icon-9.png') no-repeat;
		background-size: 100% 100%;
		position: fixed;
		right: 0.28rem;
		top: 45%;
	}
}
</style>
